export default "__VITE_ASSET__b72ef518__"